import { render, staticRenderFns } from "./FfgHeader.vue?vue&type=template&id=0c81d21e&scoped=true&"
import script from "./FfgHeader.vue?vue&type=script&lang=js&"
export * from "./FfgHeader.vue?vue&type=script&lang=js&"
import style0 from "./FfgHeader.vue?vue&type=style&index=0&id=0c81d21e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81d21e",
  null
  
)

export default component.exports